import { SponsorTypeEnumKeys } from "./shapes/SponsorTypeEnum"

const IndexSponsorsItemSchema = {
  type: { enum: SponsorTypeEnumKeys },
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default IndexSponsorsItemSchema
